"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icons = require("../Icons");
var _classnames = _interopRequireDefault(require("classnames"));
var _VideoModule = _interopRequireDefault(require("./Video.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Video = _ref => {
  var className = _ref.className,
    src = _ref.src,
    poster = _ref.poster,
    autoPlay = _ref.autoPlay,
    loop = _ref.loop,
    onError = _ref.onError;
  var videoRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isMuted = _useState2[0],
    setIsMuted = _useState2[1];
  var _useState3 = (0, _react.useState)(autoPlay),
    _useState4 = _slicedToArray(_useState3, 2),
    isPlaying = _useState4[0],
    setIsPlaying = _useState4[1];
  var togglePlayPause = () => {
    var video = videoRef.current;
    if (video) {
      if (video.paused) {
        video.play();
        setIsPlaying(true);
      } else {
        video.pause();
        setIsPlaying(false);
      }
    }
  };
  var toggleMute = event => {
    var video = videoRef.current;
    if (video) {
      video.muted = !video.muted;
      setIsMuted(video.muted);
      event.preventDefault();
    }
  };
  (0, _react.useEffect)(() => {
    var video = videoRef.current;
    var handleContainerClick = () => {
      if (isPlaying) {
        video === null || video === void 0 || video.pause();
        setIsPlaying(false);
      } else {
        video === null || video === void 0 || video.play();
        setIsPlaying(true);
      }
    };
    video === null || video === void 0 || video.addEventListener('click', handleContainerClick);
    return () => {
      video === null || video === void 0 || video.removeEventListener('click', handleContainerClick);
    };
  }, [isPlaying]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_VideoModule.default.VideoContainer, className)
  }, /*#__PURE__*/_react.default.createElement("video", {
    "data-testid": "video-element",
    ref: videoRef,
    src: src,
    poster: poster,
    onError: onError,
    autoPlay: autoPlay,
    loop: loop,
    muted: isMuted
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _VideoModule.default.Controls
  }, /*#__PURE__*/_react.default.createElement("button", {
    "data-testid": "play-button",
    className: _VideoModule.default.Control,
    type: "button",
    onClick: togglePlayPause,
    "aria-label": isPlaying ? 'Pause video' : 'Play video'
  }, isPlaying ? /*#__PURE__*/_react.default.createElement(_Icons.IconGrid, {
    isFilled: true,
    color: "#ffffff",
    size: 16
  }) : /*#__PURE__*/_react.default.createElement(_Icons.IconPlay, {
    isFilled: true,
    color: "#ffffff",
    size: 16
  })), /*#__PURE__*/_react.default.createElement("button", {
    "data-testid": "mute-button",
    className: _VideoModule.default.Control,
    type: "button",
    onClick: toggleMute,
    "aria-label": isMuted ? 'Unmute video' : 'Mute video'
  }, isMuted ? /*#__PURE__*/_react.default.createElement(_Icons.IconVolumeX, {
    isFilled: true,
    color: "#ffffff",
    size: 16
  }) : /*#__PURE__*/_react.default.createElement(_Icons.IconVolumeMax, {
    isFilled: true,
    color: "#ffffff",
    size: 16
  }))));
};
exports.Video = Video;
//# sourceMappingURL=Video.js.map